<template v-if="collection && collection.length > 1">
  <nav v-if="show" :class="`${name}`">
    <button
      :aria-label="cms.copy_previous"
      :class="[`${name}__button`, `${name}__button--left`, 'icon-arrow-left']"
      :disabled="pageNumerical <= 1"
      @click="prevSlide"
    ></button>

    <p v-if="cms.copy_of" :class="`${name}__copy`">
      <span>{{ pageNumerical }}</span> {{ cms.copy_of }}
      <span>{{ collection.length }}</span>
    </p>

    <button
      :aria-label="cms.copy_next"
      :class="[`${name}__button`, `${name}__button--right`, 'icon-arrow-right']"
      :disabled="pageNumerical >= collection.length"
      @click="nextSlide"
    >
      <progress-ring
        v-if="autoplay"
        slot="control"
        :progress="progress"
        :radius="29"
        :stroke="2"
      ></progress-ring>
    </button>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import ProgressRing from '~/components/atoms/a-svgs/a-svg-progress'
export default {
  components: { ProgressRing },
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
    collection: {
      type: Array,
      default() {
        return []
      },
    },
    carousel: {
      type: Object,
      default() {
        return {
          slidePage: 0,
        }
      },
    },
    autoplay: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      name: 'm-carousel-nav',
      show: false,
      progress: 0,
    }
  },
  computed: {
    ...mapGetters({
      mq: 'globals/getMq',
    }),
    paused() {
      return this.carousel.paused
    },
    pageNumerical() {
      return this.carousel.slidePage + 1
    },
    currentPage() {
      return this.carousel.slidePage
    },
  },
  watch: {
    currentPage() {
      this.progressRingStop()
      if (!this.paused && this.autoplay) {
        setTimeout(() => {
          this.progressRingStart()
        }, 1000)
      }
    },
    paused(newValue) {
      if (newValue === true) this.progressRingStop()
      if (newValue === false) {
        setTimeout(() => {
          this.progressRingStart()
        }, 1000)
      }
    },
  },
  mounted() {
    if (this.mq.length > 0) {
      this.show = true
    }
  },
  created() {
    this.progressRingStart()
  },
  methods: {
    progressRingStart() {
      if (this.autoplay) {
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          this.progress += 1
          if (this.progress === 100) {
            clearInterval(this.interval)
            this.nextSlide()
          }
        }, 50)
      }
    },
    progressRingStop() {
      clearInterval(this.interval)
      this.progress = 0
    },
    nextSlide() {
      this.$emit(
        'on-next-slide',
        this.currentPage < this.collection.length - 1 ? this.currentPage + 1 : 0
      )
    },
    prevSlide() {
      this.$emit(
        'on-prev-slide',
        this.currentPage > 0 ? this.currentPage - 1 : this.collection.length - 1
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.m-carousel-nav {
  flex-direction: row;
  display: flex;
  align-items: center;

  &__button {
    pointer-events: auto;
    color: inherit;
    background: none;
    border: solid 1px;
    border-radius: 50%;
    height: 54px;
    position: relative;
    width: 54px;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border 0.2s ease-in-out;

    &::before {
      border-radius: 50%;
      font-size: 20px;
      left: 50%;
      padding: 10px;
      position: absolute;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }

    &:hover,
    &:active {
      cursor: pointer;
      background: transparent;
      border: solid 1px;
    }
    &:focus {
      outline: 0;
    }

    &:disabled,
    &.disabled {
      pointer-events: none;
      color: inherit;
      background-color: transparent;
      border-color: inherit;
      opacity: 0.4;
    }
  }

  &__button--left {
    margin-right: 6px;
  }

  &__button--right {
    position: relative;
    margin-left: 6px;
  }

  &__copy {
    margin: 0 6px;
    min-width: 50px;
    text-align: center;
    display: none;
  }

  &__progress-ring {
    opacity: 0;
    position: absolute;
    top: calc(100vh - 168px);
    right: calc(50% - 59px);
  }
}

@include media-breakpoint-up(sm) {
  .m-carousel-nav {
    &__copy {
      display: initial;
    }
  }
}
</style>
